module.exports = __webpack_public_path__ + "img/24.0059927d.jpg";